import { Component, OnInit, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CoreService } from '../../core/header/core.service';
import { QRCodeService } from './qrcode.service';
import { QRCodeModel } from './qrcode.model';
import QrScanner from 'qr-scanner';
import { Option } from '../../shared/models/option.model';

@Component({
    selector: 'convfact-qrcodeopen',
    templateUrl: './qrcode-open.component.html',
    styleUrls: ['./qrcode.component.css'],
    standalone: false
})
export class QRCodeOpenComponent implements OnInit, OnDestroy {

  @ViewChild('video', {static: false}) videoElem: ElementRef;
  scanner: QrScanner;
  cameraList: any[] = [];
  selectedCameraId: string;

  public get cameraOptions(): Option[] {
    return (this.cameraList || []).map(camera => ({ label: camera.label, value: camera.id }));
  }

  constructor(public dialogRef: MatDialogRef<QRCodeOpenComponent>,private qrCodeService: QRCodeService, public snackBar: MatSnackBar,
    private coreService: CoreService) {
  }

  ngOnInit() {
    this.coreService.setName("Código QR");
    this.scanner = new QrScanner(this.videoElem.nativeElement, result => this.parseResult(result),
    {
      highlightScanRegion: true,
      highlightCodeOutline: true,
    });

    this.scanner.start().then(() => {
      QrScanner.listCameras(true).then(cameras => {
        cameras.forEach(camera => {
          this.cameraList.push(camera);
        })
      });
    });
  }

  parseResult(result) {
    const data = JSON.parse(result.data);
    const qrcode = new QRCodeModel();
    qrcode.uid = data.uid;
    qrcode.ownerUid = data.ownerUid;
    qrcode.type = data.type;
    qrcode.ver = data.ver;

    this.closeDialog(); // To prevent send multiple requests

    this.qrCodeService.sendQR(qrcode).then(res => {
      alert(res);
      this.closeDialog();
    });
  }

  ngOnDestroy() {
    this.scanner.stop();
  }

  closeDialog() {
    this.scanner.stop();
    this.dialogRef.close();
  }

  changeCamera(cameraId: string) {
    this.scanner.setCamera(cameraId);
  }
  public trackByIndex(i: number) { return i; }

}
